import { queryOptions } from "@tanstack/react-query";
import type {
  MyInvitationListData,
  MyInvitationListResponse,
} from "@/app/invitations/types";
import { coordinatorRootApi } from "@/lib/api";
import { invitationKeys } from "./query-keys";

export const fetchMyInvitations = async (): Promise<MyInvitationListData> => {
  const { data } =
    await coordinatorRootApi.get<MyInvitationListResponse>("/invitations");
  return data.data;
};

export const myInvitationsQueryOptions = queryOptions<MyInvitationListData>({
  queryKey: invitationKeys.myInvitations(),
  queryFn: () => fetchMyInvitations(),
});
